exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Steps {\n  margin-top: 1.4em;\n  margin-bottom: 1.4em;\n}\n\n.Steps .row .step {\n  float: left;\n  width: 33.33333333% !important;\n}\n\n.Steps .bg {\n  -webkit-background-size: 100% 60px;\n          background-size: 100% 60px;\n  background-repeat: no-repeat;\n}\n\n.Steps .bg.step_1{\n  background-image: url(" + require("./images/step_1.png") + ");\n}\n\n.Steps .bg.step_2{\n  background-image: url(" + require("./images/step_2.png") + ");\n}\n\n.Steps .bg.step_3{\n  background-image: url(" + require("./images/step_4.png") + ");\n}\n\n.Steps .step {\n  position: relative;\n  vertical-align: middle;\n  font-family: 'Passion One', cursive;\n  font-size: 45px;\n  text-align: center;\n  color: #FFFFFF;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.Steps .step.active {\n  color: rgba(255, 255, 255, 1);\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/components/Steps/Steps.css
 ** module id = 430
 ** module chunks = 0
 **/